import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ToastrService } from "ngx-toastr";

import { AppEndpoint } from "app/app.endpoints";
import { catchError, map } from "rxjs/operators";
import { LOCAL_STORAGE_KEYS } from "../shared/enums/LocalStorage.enum";
import { Router } from "@angular/router";

@Injectable({ providedIn: "root" })
export class SessionService {
  private url = `${AppEndpoint.BASE_URL}/private/sessions`;

  constructor(
    private readonly toastrService: ToastrService,
    private readonly http: HttpClient,
    private readonly router: Router
  ) {}

  switchSession = (userId: string) => {
    console.log("Switching session to userId: ", userId);
    return this.http.post<any>(`${this.url}/switch-session/${userId}`, {}).pipe(
      map(async ({ token, enableSenderManagement }) => {
        console.log("Enabled Sender Management SWITCH SESSION: ", enableSenderManagement);
        const currentToken = localStorage.getItem(LOCAL_STORAGE_KEYS.TOKEN);
        localStorage.setItem(LOCAL_STORAGE_KEYS.SHARED_TOKEN, currentToken);
        localStorage.setItem(LOCAL_STORAGE_KEYS.TOKEN, token);
        localStorage.removeItem(LOCAL_STORAGE_KEYS.AUTH);

        // Store enableSenderManagement in AUTH
        // const authData = { enableSenderManagement: enableSenderManagement ?? false };
        // localStorage.setItem(LOCAL_STORAGE_KEYS.AUTH, JSON.stringify(authData));
        await this.router.navigateByUrl("/dashboard");
        window.location.reload();
      }),
      catchError((error: HttpErrorResponse) => {
        console.error("Error al cambiar de sesión: ", error);
        this.toastrService.error("Error al cambiar sesión");
        throw error;
      })
    );
  };

  restoreSession = () => {
    const originalSession = localStorage.getItem(
      LOCAL_STORAGE_KEYS.SHARED_TOKEN
    );
    localStorage.setItem(LOCAL_STORAGE_KEYS.TOKEN, originalSession);
    localStorage.removeItem(LOCAL_STORAGE_KEYS.AUTH);
    localStorage.removeItem(LOCAL_STORAGE_KEYS.SHARED_TOKEN);
    this.toastrService.success("Sesión recuperada");
    setTimeout(async () => {
      await this.router.navigateByUrl("/dashboard");
      window.location.reload();
    }, 1000);
  };
}
